module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"addQuestion":"Добавить вопрос","additional":"Дополнительные вопросы","subhead":"Хотите задать вопрос? Попробуйте сперва найти его в библиотеке.","cancel":"Отмена","save":"Сохранить"}}')
  delete Component.options._Ctor
}
